import { format, parse } from "date-fns";
import { number } from "zod";

export const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const colorCode = {
  booked: "#BDBDBD",
  consulted: "#EAB308",
  document_submitted: "#A855F7",
  verified_by_unilinks: "#6366F1",
  successfully_applied: "#3B82F6",
  university_approved: "#14B8A6",
  university_rejected: "#F04438",
  student_offer_accepted: "#06B6D4",
  payment_received: "#06B6D4",
  payment_success: "#1DA750",
  dropout: "#F04438",
};

export const allStatus = [
  { label: "Booked", value: "booked" },
  { label: "Consulted", value: "consulted" },
  { label: "Documents Submitted", value: "document_submitted" },
  { label: "Verification", value: "verified_by_unilinks" },
  { label: "Application in progress", value: "successfully_applied" },
  { label: "University Approved", value: "university_approved" },
  { label: "University Rejected", value: "university_rejected" },
  {
    label: "Make Payment",
    value: "student_offer_accepted",
  },
  { label: "Payment in Review", value: "payment_received" },
  { label: "Enrollment", value: "payment_success" },
  { label: "Withdrew", value: "dropout" },
];

export const studentApplicationStatus = [
  { label: "Document submitted", value: ["document_submitted"] },
  { label: "Verified", value: ["verified_by_unilinks"] },
  { label: "Applied", value: ["successfully_applied"] },
  {
    label: "Waiting for student’s response",
    value: ["university_approved", "student_offer_accepted"],
  },
  { label: "Payment Done", value: ["payment_received"] },
  { label: "Enrolled", value: ["payment_success"] },
];

export const getApplicationStatus = (status) => {
  const activeStatus = allStatus.find((s) => s.value === status);
  return activeStatus?.label || "Unknown";
};

export const getStatusColorCode = (status) => {
  return colorCode[status];
};

export const formatTime = (time) => {
  const dateTime = parse(
    `1970-01-01 ${time}`,
    "yyyy-MM-dd HH:mm:ss",
    new Date(),
  );
  return format(dateTime, "hh:mm a");
};

export const agentOnboardSections = [
  { label: "Personal Info", value: "personal_info" },
  { label: "Academic Info", value: "academic_info" },
  { label: "Work experience info", value: "workexp_info" },
  { label: "Schedule info", value: "timeslot" },
];

export const getPrioritySeverity = (priority) => {
  if (priority === "High") {
    return "error";
  } else if (priority === "Medium") {
    return "warning";
  } else if (priority === "Normal") {
    return "success";
  }
};

export const getUniversityLogo = (media) => {
  const logo = media?.find((m) => m.collection_name === "university_logo");
  if (logo) return logo?.original_url;

  return null;
};

export const getUniversityImages = (media) => {
  const images = media
    ?.filter((m) => m.collection_name !== "university_logo")
    ?.map((m) => ({
      itemImageSrc: m.original_url,
      thumbnailImageSrc: m.original_url,
      alt: m.file_name,
      title: m.file_name,
    }));

  return images || [];
};

export const isValidEmail = (value) => {
  if (!value && value?.length > 0) return false;
  const pattern = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;
  return pattern.test(value);
};

export const getRankingLabel = (ranking) => {
  return ranking?.number == 0 || ranking?.number == "N/A"
    ? "Ranking Not Available"
    : ranking?.name + " " + ranking?.number;
};

export const getTuitionFee = (tuitionFee) => {
  if (!tuitionFee) return "Data Not Available";

  if (tuitionFee?.price == 0) return "Free";
  if (tuitionFee?.price == -1) return "Data Not Available";

  return `${numberFormatter.format(tuitionFee?.price)} ${tuitionFee?.currency} ${tuitionFee?.approach ? `(Approx)` : ""}`;
};

export const formatPaymentType = (paymentType, tuitionFeeStr) => {
  const tuitionFee = Number(tuitionFeeStr);
  if (tuitionFee === 0 || tuitionFee === -1 || tuitionFeeStr === undefined)
    return "";

  return " / " + paymentType?.toLocaleLowerCase();
};

export const getApplicationFee = (tuitionFee) => {
  if (!tuitionFee) return "Data Not Available";

  if (tuitionFee?.application_fee == 0) return "Free";

  return `${numberFormatter.format(tuitionFee?.application_fee)} ${tuitionFee?.application_fee_currency}`;
};

export const getCitiesName = (cities) => {
  if (!cities || cities?.length == 0) return null;
  return cities
    ?.map((city) => city?.name)
    ?.join(", ")
    ?.replaceAll("Thailand,", "");
};

export const numberFormatter = new Intl.NumberFormat();
